module.exports = __webpack_public_path__ + "media/images/flags/1x1/bhr-247b3aa5db883336d5755323900ca2eb.svg";